module.exports = __webpack_public_path__ + "static/media/reflexive.ad38b345.png";